<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('policy_no')"
                    v-model="form.policy_no"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    :label="$t('insurance_company')"
                    v-model="form.company_id"
                    :rules="[isRequired]"
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    @update:search-input="searchInsuranceCompanies"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('coverage_value')"
                    v-model="form.coverage_value"
                    :rules="[isRequired, isNumeric]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <DatePicker
                    :label="$t('start_date')"
                    v-model="startDate"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12" md="6">
                <TimePicker
                    :label="$t('start_time')"
                    v-model="startTime"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <DatePicker
                    :label="$t('end_date')"
                    v-model="endDate"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12" md="6">
                <TimePicker
                    :label="$t('end_time')"
                    v-model="endTime"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-switch
                    :label="$t('riot_coverage')"
                    v-model="form.riot_coverage"
                    hide-details="auto"
                ></v-switch>
            </v-col>
            <v-col>
                <v-switch
                    :label="$t('music_player_coverage')"
                    v-model="form.music_player_coverage"
                    hide-details="auto"
                ></v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-switch
                    :label="$t('agency_maintenance')"
                    v-model="form.agencey_maintenance"
                    hide-details="auto"
                ></v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('passengers_count')"
                    v-model="form.passengers_count"
                    :rules="[isRequired, isNumeric]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('cost')"
                    v-model="form.cost"
                    :rules="[isRequired, isNumeric]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-textarea
                    :label="$t('other_terms')"
                    v-model="form.other_terms"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import DatePicker from './../common/DatePicker.vue';
import TimePicker from '../common/TimePicker.vue';
import { isRequired, isNumeric } from './../../utils/validations';
import company from './../../services/insurance/company';
import moment from 'moment';

export default {
    components: {
        DatePicker,
        TimePicker
    },
    props: {
        value: Object
    },
    data() {
        return {
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,
            companies: [],
            companiesLoading: false,
            form: {
                policy_no: "",
                company_id: null,
                coverage_value: 0,
                start_at: null,
                end_at: null,
                riot_coverage: false,
                music_player_coverage: false,
                agency_maintenance: false,
                passengers_count: 0,
                cost: 0,
                other_terms: ""
            }
        }
    },
    computed: {
        startAt() {
            return `${this.startDate} ${this.startTime}`
        },
        endAt() {
            return `${this.endDate} ${this.endTime}`
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        },
        startAt() {
            this.endDate = moment(this.startDate).add(1, "year").format("YYYY-MM-DD")
            this.endTime = this.startTime;
            this.form = {...this.form, start_at: this.startAt}

        },
        endAt() {
            this.form = {...this.form, end_at: this.endAt}
        }
    },
    methods: {
        isRequired,
        isNumeric,
        searchInsuranceCompanies(query) {
            this.companiesLoading = true;
            company.search(query).then(res => {
                this.companies = [...this.companies, ...res.data];
            }).finally(() => {
                this.companiesLoading = false;
            })
        }
    },
    created() {
        this.form = {...this.value}
    }
}
</script>

<style>

</style>